import { BaseApiRouteService } from "mrb/core";

class LoadioContentProfileApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/content-profiles");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,fields}`, filter);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?fields}`, id, options);
    }

    getDeviceCount(id) {
        return `${this.base}/${id}/device-count`;
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(`${this.base}/{id}`, resource);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }

    assignArtists(id) {
        return `${this.base}/${id}/artists`;
    }

    unassignArtists(id) {
        return `${this.base}/${id}/artists`;
    }

    enableAllArtists(id, genreId, searchQuery) {
        return `${this.base}/${id}/artists/all${this._buildAllArtistsQuery(genreId, searchQuery)}`;
    }

    disableAllArtists(id, genreId, searchQuery) {
        return `${this.base}/${id}/artists/all${this._buildAllArtistsQuery(genreId, searchQuery)}`;
    }

    _buildAllArtistsQuery(genreId, searchQuery) {
        const params = [];
        if (genreId) params.push(`genreId=${encodeURIComponent(genreId)}`);
        if (searchQuery) params.push(`searchQuery=${encodeURIComponent(searchQuery)}`);
        return params.length ? `?${params.join("&")}` : "";
    }
}

export default LoadioContentProfileApiRouteService;
